import { HttpTypes } from "@medusajs/types"
import { Text } from "@medusajs/ui"

type LineItemOptionsProps = {
  variant: HttpTypes.StoreProductVariant | undefined
  "data-testid"?: string
  "data-value"?: HttpTypes.StoreProductVariant
  metadata?: Record<string, unknown>
}

const LineItemOptions = ({
  variant,
  "data-testid": dataTestid,
  "data-value": dataValue,
  metadata,
}: LineItemOptionsProps) => {
  // If we have metadata, display the color selections
  if (metadata && Object.keys(metadata).length > 0) {
    // Filter out non-color options (assuming color options have keys like "Base", "Color 1", etc.)
    const colorOptions = Object.entries(metadata)
      .filter(([key]) => {
        // Filter out internal properties and empty values
        return key !== "__typename" && key !== "id" &&
               metadata[key] !== null && metadata[key] !== undefined && metadata[key] !== "";
      })
      .map(([key, value]) => {
        // Format the key-value pair nicely
        return `${key}: ${value}`;
      })
      .join(", ");

    // Only return if we have options to display
    if (colorOptions) {
      return (
        <Text
          data-testid={dataTestid}
          data-value={dataValue}
          className="inline-block text-xs text-white/80 w-full overflow-hidden text-ellipsis tracking-wide"
        >
          {colorOptions}
        </Text>
      );
    }

    // If no valid options found, return null
    return null;
  }

  // Fallback to variant title if no metadata
  return (
    <Text
      data-testid={dataTestid}
      data-value={dataValue}
      className="inline-block text-xs text-white/80 w-full overflow-hidden text-ellipsis tracking-wide"
    >
      Variant: {variant?.title}
    </Text>
  )
}

export default LineItemOptions
